import CommonStore from './common';
export default {
  mixins: [CommonStore],
  data() {
    return {
      // CHANGED: переименовываем под ваш шаблон,
      // чтобы точно совпадало с $pointsContainer = 'collectionPointItems'
      loadingCollectionPoints: false,
      collectionPointActive: null,
      collectionPointItems: [] // <-- было: collectionPoints: null
    };
  },

  // CHANGED: если вы используете chosen/select2, можно добавить watch,
  // чтобы после обновления массива триггерить chosen:updated:
  watch: {
     collectionPointItems() {
       this.$nextTick(() => {
         // Например:
         // $('#collectionPointSelect').trigger('chosen:updated');
         console.log('Nottrigger')
       });
     }
  },
  methods: {
    getCollectionPointsCacheKey(params) {
      return JSON.stringify({
        cityId: +params.cityId,
        max: -1,
      });
    },
    getCollectionPointLabel(category, currency, addScopes = true, defaultValue = '') {
      let categoryType = _.get(category, 'config_type', -1);
      let currencyType = _.get(currency, 'config_type', -1);

      let keyRule = ['labels', 'forExcursionPrices', categoryType, currencyType];
      let value = _.get(window._CONFIG_RULES, keyRule, defaultValue);
      return !_.isEmpty(value) ? (addScopes ? '(' + value + ')' : value) : defaultValue;
    },

    clearKeyActiveCollectionPointsCache() {
      this.collectionPointActive = null;
    },

    setActiveCollectionPointsCache(params, items) {
      console.log('setActiveCollectionPointsCache')
      const key = JSON.stringify(params);
      this.collectionPointActive = key;
      this.toCache('collectionPoints', key, items);
      this.collectionPointItems = items; // <-- это ключевой момент
    },

    getCollectionPointQueryObject(cityId, params = {}) {
      // Формируете объект с параметрами для запроса
      return _.merge(
        {
          cityId: cityId,
          max: -1
        },
        params
      );
    },

    fetchCollectionPoints(
      params,
      handleBeforeRequest = false,
      handleSuccess = (items) => {},
      handleError = () => {},
      additionallyParams = {},
      noCache = false // <--- добавили флаг
    ) {
      console.log('POINT')
      this.loadingCollectionPoints = true;
      if (handleBeforeRequest) {
        handleBeforeRequest();
      }

      console.log('PARAMS=> :',params)
      console.log('additionallyParams=> :',additionallyParams)

      //additionallyParams.exId = 129
      const keyCache = this.getCollectionPointsCacheKey(params);

      // Если noCache = true, игнорируем кэш
      if (noCache) {
        console.log('⚠️ fetchCollectionPoints: КЭШ ОТКЛЮЧЁН', keyCache);

        return axios.get('pc-items', {
          params: _.merge(params, additionallyParams)
        })
          .then((response) => {
            console.log('✅ Ответ сервера (noCache):', response);

            let items = _.get(response, 'data.data', []);
            items = items.filter(item => +item.city_id === +params.cityId);

            this.collectionPointActive = keyCache;
            this.toCache('collectionPoints', keyCache, items); // можно кэшировать всё равно
            this.collectionPointItems = items;

            if (handleSuccess) handleSuccess(items);
          })
          .catch((error) => {
            if (handleError) handleError(error);
            console.error('❌ Ошибка (noCache):', error);
          })
          .finally(() => {
            this.loadingCollectionPoints = false;
          });
      }

      // Стандартный режим с кэшем:
      this.fromOrToCache('collectionPoints', keyCache, (fromCache, getOrSet) => {
        if (fromCache) {
          console.log('📦 fetchCollectionPoints: данные из кэша', keyCache);
          this.collectionPointActive = keyCache;
          this.collectionPointItems = getOrSet();
          if (handleSuccess) handleSuccess(this.collectionPointItems);
          this.loadingCollectionPoints = false;
          return;
        }

        console.log('🌐 fetchCollectionPoints: реальный запрос', keyCache);
        axios.get('pc-items', {
          params: _.merge(params, additionallyParams)
        })
          .then((response) => {
            let items = _.get(response, 'data.data', []);
            items = items.filter(item => +item.city_id === +params.cityId);

            getOrSet(items);
            this.collectionPointActive = keyCache;
            this.collectionPointItems = items;

            if (handleSuccess) handleSuccess(items);
          })
          .catch((error) => {
            if (handleError) handleError(error);
            console.error('❌ Ошибка при загрузке:', error);
          })
          .finally(() => {
            this.loadingCollectionPoints = false;
          });
      });
    }



  }
};
